//
// Copyright (c) 2023 Emplifi, Inc.
//

import { InputView, type LabeledFieldView, type Locale } from "ckeditor5";
import InputEmailView from "./inputEmailView";

export default class InputPhoneView extends InputView {
  constructor(locale: Locale) {
    super(locale);
    this.extendTemplate({
      attributes: {
        class: ["ck-input-text", "ak-input-phone"],
        type: "tel",
      },
    });
  }
}

export function createLabeledInputPhone(
  labeledFieldView: LabeledFieldView,
  viewUid: string,
  statusUid: string,
): InputEmailView {
  const inputPhoneView = new InputPhoneView(labeledFieldView.locale!);
  inputPhoneView.set({
    ariaDescribedById: statusUid,
    id: viewUid,
  });
  inputPhoneView.bind("isReadOnly").to(labeledFieldView, "isEnabled", (enabled) => !enabled);
  inputPhoneView.bind("hasError").to(labeledFieldView, "errorText", (errorText) => !!errorText);
  labeledFieldView.bind("isEmpty", "isFocused", "placeholder").to(inputPhoneView);
  return inputPhoneView;
}
